import { $ } from '@zeus/index'
import { typedGql } from '@zeus/typedDocumentNode'
import { scalars } from '~/gql/utils/scalars'

/** Déclare l'abandon d'un inscrit (#324), avec son motif et une précision facultative. */
export const GQL_DECLARE_DROPOUT = typedGql('mutation', { scalars })({
  declareDropout: [{ input: $('input', 'DeclareDropoutInput!') }, true],
})

/** Annule l'abandon d'un inscrit qui reprend sa formation (#324). */
export const GQL_CANCEL_DROPOUT = typedGql('mutation', { scalars })({
  cancelDropout: [{ input: $('input', 'SessionEnrollmentRefInput!') }, true],
})
